import * as React from 'react';
import Typography from '@mui/material/Typography';
import { Button, Container, Box } from '@mui/material';
import TelemetryUploader from './TelemetryUploader';

export default function AttachTelemetry({
  isTelemetryUpload,
  setTelemetryUpload,
  selectedRunDetails,
  liftTelemetryFileMetaData,
  telemetryFileMetaData,
  telemetryDataArray,
  liftTelemetryDataArray,
}) {
  return (
    <React.Fragment>
      <Container>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            columnGap: '20px',
            paddingBottom: '20px',
          }}
        >
          <Button
            onClick={() => setTelemetryUpload(true)}
            variant="outlined"
            size="large"
          >
            File Upload
          </Button>
          <Button
            onClick={() => setTelemetryUpload(false)}
            variant="disabled"
            size="large"
          >
            HTR Device Stream (DB)
          </Button>
        </Box>
        {isTelemetryUpload ? (
          <TelemetryUploader
            selectedRunDetails={selectedRunDetails}
            telemetryFileMetaData={telemetryFileMetaData}
            liftTelemetryFileMetaData={liftTelemetryFileMetaData}
            telemetryDataArray={telemetryDataArray}
            liftTelemetryDataArray={liftTelemetryDataArray}
          />
        ) : (
          <React.Fragment>
            <Typography>Will implement DB stuff later</Typography>
          </React.Fragment>
        )}
      </Container>
    </React.Fragment>
  );
}
